import { render, staticRenderFns } from "./SwiftSensorData.vue?vue&type=template&id=312d1226&scoped=true"
import script from "./SwiftSensorData.vue?vue&type=script&lang=js"
export * from "./SwiftSensorData.vue?vue&type=script&lang=js"
import style0 from "./SwiftSensorData.vue?vue&type=style&index=0&id=312d1226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d1226",
  null
  
)

export default component.exports